import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=049f1f8d&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=049f1f8d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049f1f8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049f1f8d')) {
      api.createRecord('049f1f8d', component.options)
    } else {
      api.reload('049f1f8d', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=049f1f8d&scoped=true", function () {
      api.rerender('049f1f8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/Main.vue"
export default component.exports